import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed, watch } from 'vue'
import { useGeneralStore } from '@/pinia'
import ModalCreateTicket from '@/components/features/tickets/ModalCreateTicket.vue'
import ModalEditTicket from '@/components/features/tickets/ModalEditTicket.vue'
import ModalEditLink from '@/components/features/attachments/ModalEditLink.vue'
import ModalEditPoi from '@/design-system/organisms/ModalEditPoi.vue'
import ModalPreviewFile from '@/components/features/attachments/ModalPreviewFile.vue'
import ModalUploadFiles from '@/components/features/attachments/ModalUploadFiles.vue'
import ModalUploadTicketFiles from '@/components/features/tickets/ModalUploadTicketFiles.vue'
import ModalEditRoom from '@/components/features/info-display/ModalEditRoom.vue'
import ModalCreateAssets from '@/design-system/organisms/ModalCreateAssets.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'OverlayModals',
  setup(__props) {

const piniaStore = useGeneralStore()
const { setShowOverlayModalPinia, setShowOverlayModalOnModalPinia } = useGeneralStore()

const currentOverlayModalPinia = computed(() => {
  return piniaStore.currentOverlayModalPinia
})
const currentOverlayModalOnModalPinia = computed(() => {
  return piniaStore.currentOverlayModalOnModalPinia
})
const showOverlayModalPinia = computed(() => {
  return piniaStore.showOverlayModalPinia
})
const showOverlayModalOnModalPinia = computed(() => {
  return piniaStore.showOverlayModalOnModalPinia
})

function closeModal() {
  setShowOverlayModalPinia(false)
}
function closeModalOnModal() {
  setShowOverlayModalOnModalPinia(false)
}
watch(showOverlayModalPinia, (newValue) => {
  if (!newValue && showOverlayModalOnModalPinia.value) setShowOverlayModalOnModalPinia(false)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showOverlayModalPinia.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (currentOverlayModalPinia.value === 'createTicket')
            ? (_openBlock(), _createBlock(ModalCreateTicket, {
                key: 0,
                onCloseCreateTicketModal: _cache[0] || (_cache[0] = ($event: any) => (closeModal()))
              }))
            : _createCommentVNode("", true),
          (currentOverlayModalPinia.value === 'editTicket')
            ? (_openBlock(), _createBlock(ModalEditTicket, {
                key: 1,
                onCloseEditTicketModal: _cache[1] || (_cache[1] = ($event: any) => (closeModal()))
              }))
            : _createCommentVNode("", true),
          (currentOverlayModalPinia.value === 'editLink')
            ? (_openBlock(), _createBlock(ModalEditLink, {
                key: 2,
                onCloseEditLinkModal: _cache[2] || (_cache[2] = ($event: any) => (closeModal()))
              }))
            : _createCommentVNode("", true),
          (currentOverlayModalPinia.value === 'editPoi')
            ? (_openBlock(), _createBlock(ModalEditPoi, {
                key: 3,
                onCloseEditPoiModal: _cache[3] || (_cache[3] = ($event: any) => (closeModal()))
              }))
            : _createCommentVNode("", true),
          (currentOverlayModalPinia.value === 'createAssets')
            ? (_openBlock(), _createBlock(ModalCreateAssets, {
                key: 4,
                onCloseCreateAssetsModal: _cache[4] || (_cache[4] = ($event: any) => (closeModal()))
              }))
            : _createCommentVNode("", true),
          (currentOverlayModalPinia.value === 'previewFilePinia')
            ? (_openBlock(), _createBlock(ModalPreviewFile, {
                key: 5,
                onClosePreviewFileModal: _cache[5] || (_cache[5] = ($event: any) => (closeModal()))
              }))
            : _createCommentVNode("", true),
          (currentOverlayModalPinia.value === 'uploadFilesPinia')
            ? (_openBlock(), _createBlock(ModalUploadFiles, {
                key: 6,
                onCloseUploadFilesModal: _cache[6] || (_cache[6] = ($event: any) => (closeModal()))
              }))
            : _createCommentVNode("", true),
          (currentOverlayModalPinia.value === 'editRoomPinia')
            ? (_openBlock(), _createBlock(ModalEditRoom, {
                key: 7,
                onCloseEditRoomModal: _cache[7] || (_cache[7] = ($event: any) => (closeModal()))
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (showOverlayModalOnModalPinia.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (currentOverlayModalOnModalPinia.value === 'editTicketLink')
            ? (_openBlock(), _createBlock(ModalEditLink, {
                key: 0,
                onCloseEditLinkModal: _cache[8] || (_cache[8] = ($event: any) => (closeModalOnModal()))
              }))
            : _createCommentVNode("", true),
          (currentOverlayModalOnModalPinia.value === 'previewTicketFilePinia')
            ? (_openBlock(), _createBlock(ModalPreviewFile, {
                key: 1,
                onClosePreviewFileModal: _cache[9] || (_cache[9] = ($event: any) => (closeModalOnModal()))
              }))
            : _createCommentVNode("", true),
          (currentOverlayModalOnModalPinia.value === 'uploadTicketFiles')
            ? (_openBlock(), _createBlock(ModalUploadTicketFiles, {
                key: 2,
                onCloseUploadFilesModal: _cache[10] || (_cache[10] = ($event: any) => (closeModalOnModal()))
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})